import BasicDataTable from "../../Component/BasicComponents/BasicDataTable";
import { useEffect, useState } from "react";
import RouteModal from "../../Component/BasicComponents/Modal/RouteModal";
import { FaEdit } from "react-icons/fa";
import PageHeader from "../../Component/BasicComponents/HeaderBreadCrumbs";
import {
  useAddTicketReplies,
  useTicketRepliesList,
  useUpdateTicketReplies,
} from "./hooks/useTicket";
import { useLocation } from "react-router-dom";
import CustomInput from "../../Component/BasicComponents/CustomInput";
import { Btn } from "../../AbstractElements";
import { showToast } from "../../utils/toastUtils";
type Props = {};

const fileDataColumns = (handleEditFiles: (row: any) => void) => [
  {
    name: "Emp Name | Emp Code",
    selector: (row: { FirstName: string }) => row?.FirstName || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Ticket Replies",
    selector: (row: { TicketReplies: string }) => row?.TicketReplies || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Attachment URL",
    selector: (row: { AttachmentUrl: string }) => row?.AttachmentUrl || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Created At",
    selector: (row: { CreatedAt: string }) =>
      row.CreatedAt.split(".")[0] || "-",
    sortable: true,
    wrap: true,
    minWidth: "150px",
  },
  {
    name: "Action",
    cell: (row: any) => (
      <button
        onClick={() => handleEditFiles(row)}
        className="btn btn-primary d-flex align-items-center justify-content-center gap-1"
        style={{ borderRadius: "20px", padding: "3px", width: "70px" }}
      >
        <FaEdit size={14} style={{ fill: "#fff" }} /> Edit
      </button>
    ),
  },
];

const TicketReplies = (props: Props) => {
  const location = useLocation();
  const { rowData } = location?.state;
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [editModalStatus, setEditModalStatus] = useState("");
  const [rowSelected, setRowSelected] = useState<string | any | null>(null);
  const [filtersState, setFiltersState] = useState<any>({
    page: 1,
    limit: 10,
    search: null,
  });

  console.log(
    "🚀 ~ TicketReplies.tsx:67 ~ TicketReplies ~ rowSelected:",
    rowSelected
  );

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formValues, setFormValues] = useState({
    comment: "",
    attachmentUrl: "",
    ticketId: "",
    ticketCommentId: "",
  });

  const { data: ticketRepliesList, isLoading: ticketRepliesLoading } =
    useTicketRepliesList({
      enable: true,
      params: { ticketId: rowData?.Id, page: 1, limit: 10, search: "" },
    });

  // console.log("🚀 ~ TicketReplies.tsx:91 ~ TicketReplies ~ ticketRepliesList:", ticketRepliesList?.data?.pagination?.total_records)

  const { mutate: addTicket } = useAddTicketReplies();
  const { mutate: updateTicket } = useUpdateTicketReplies();

  useEffect(() => {
    if (rowSelected && editModalStatus === "Edit") {
      setFormValues({
        comment: rowSelected?.TicketReplies,
        attachmentUrl: rowSelected?.AttachmentUrl,
        ticketId: "",
        ticketCommentId: rowSelected?.Id,
      });
    }
  }, [rowSelected, editModalStatus]);

  const handlePagination = (pageNo: number) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
      };
    });
  };
  const handleonChangeRowsPerPage = (limit: any, pageNo: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        page: pageNo,
        limit: limit,
      };
    });
  };
  const handleSearch = (searchValue: any) => {
    setFiltersState((prevState: any) => {
      return {
        ...prevState,
        search: searchValue,
      };
    });
  };

  const handleSubmit = () => {
    if (editModalStatus === "Edit") {
      if (!formValues?.comment) {
        showToast.warning("Please Fill the Comment Field!");
        return;
      } else {
        setIsSubmitting(true);
        const updateTicketRepliesBody = {
          Id: formValues?.ticketCommentId,
          TicketReplies: formValues?.comment,
          AttachmentUrl: formValues?.attachmentUrl,
        };
        updateTicket(updateTicketRepliesBody, {
          onSuccess: () => {
            handleClose();
          },
          onError: (error) => {
            setIsSubmitting(false);
          },
        });
      }
    } else {
      if (!formValues?.comment) {
        showToast.warning("Please Fill the Comment Field!");
        return;
      } else {
        setIsSubmitting(true);
        const addTicketRepliesBody = {
          TicketId: rowData?.Id,
          TicketReplies: formValues?.comment,
          AttachmentUrl: formValues?.attachmentUrl,
        };
        addTicket(addTicketRepliesBody, {
          onSuccess: () => {
            handleClose();
          },
          onError: (error) => {
            setIsSubmitting(false);
          },
        });
      }
    }
  };

  const toggleModal = () => {
    setIsModalOpen(!isModalOpen);
    setEditModalStatus("");
    setRowSelected(null);
    setFormValues({
      comment: "",
      attachmentUrl: "",
      ticketId: "",
      ticketCommentId: "",
    });
    setIsSubmitting(false);
  };
  const handleClose = () => {
    setIsModalOpen(false);
    setEditModalStatus("");
    setRowSelected(null);
    setFormValues({
      comment: "",
      attachmentUrl: "",
      ticketId: "",
      ticketCommentId: "",
    });
  };

  const handleEditFiles = (row: any) => {
    setEditModalStatus("Edit");
    setIsModalOpen(!isModalOpen);
    setRowSelected(row);
  };

  return (
    <div className="p-2">
      <PageHeader
        title="Ticket Replies"
        buttons={[
          {
            label: "+ Add Ticket Comment",
            onClick: toggleModal,
            color: "#2e8dd3",
          },
          {
            label: "Excel",
            onClick: () => alert("Action 2 clicked"),
            color: "#43B9B2",
          },
        ]}
      />

      <BasicDataTable
        Title="Ticket Replies"
        data={ticketRepliesList?.data?.data || []}
        columns={fileDataColumns(handleEditFiles)}
        dynamicHeightOnRowsPerPage={true}
        showSpinner={ticketRepliesLoading}
        onChangePage={(pageNo: number) => {
          handlePagination(pageNo);
        }}
        onChangeRowsPerPage={(newPerPage: any, page: any) => {
          handleonChangeRowsPerPage(newPerPage, page);
        }}
        handleSearch={(val: any) => {
          handleSearch(val);
        }}
        paginationTotalRows={
          ticketRepliesList?.data?.pagination?.total_records || 0
        }
      />
      <RouteModal
        isOpen={isModalOpen}
        toggle={toggleModal}
        title={
          editModalStatus === "Edit"
            ? "Edit Ticket Replies"
            : "Add Ticket Replies"
        }
        size="md"
        content={
          <>
            <CustomInput
              label="Comment"
              asterisk={true}
              placeholder="Enter Comment"
              type="text"
              name="comment"
              value={formValues?.comment}
              onChange={(e) =>
                setFormValues((prev) => ({ ...prev, comment: e.target.value }))
              }
            />
            <CustomInput
              label="Attachment URL"
              placeholder="Enter Attachment URL"
              type="text"
              name="attachmentUrl"
              value={formValues?.attachmentUrl}
              onChange={(e) =>
                setFormValues((prev) => ({
                  ...prev,
                  attachmentUrl: e.target.value,
                }))
              }
            />
            <div className="d-flex justify-content-start mt-3 gap-2">
              <Btn
                style={{ backgroundColor: "#43B9B2", color: "white" }}
                type="submit"
                onClick={handleSubmit}
                disabled={isSubmitting}
              >
                {editModalStatus === "Edit" ? "Update" : "Submit"}
              </Btn>

              <Btn
                style={{
                  backgroundColor: "#F9FAFC",
                  color: "#000",
                  border: "1px solid #E0E0E0",
                }}
                type="button"
                onClick={handleClose}
              >
                Cancel
              </Btn>
            </div>
          </>
        }
      />
    </div>
  );
};

export default TicketReplies;
